"use client"

import { VStack } from "@chakra-ui/react"
import { useHypertune } from "lib/feature-flags/generated/hypertune.react"
import type React from "react"
import NavCategoryHeader from "./components/NavCategoryHeader"
import { BaseNavigationLinks, OrgNavigationLinks, RootNavigationLinks } from "./links"

const OrganizationNavigation: React.FC = () => {
    const hypertune = useHypertune()

    const displayOrgs =
        hypertune.userIsSuperadmin({ fallback: false }) &&
        Object.values(hypertune.activeFeatures().orgs).some((flag) => !!flag)

    return (
        <VStack className='flex items-start' spacing={6}>
            <BaseNavigationLinks />
            <VStack>
                <NavCategoryHeader title='Apps' />
                <RootNavigationLinks />
            </VStack>
            {displayOrgs && (
                <VStack w='full'>
                    <NavCategoryHeader title='Org' />
                    <OrgNavigationLinks />
                </VStack>
            )}
        </VStack>
    )
}

export default OrganizationNavigation
